import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../api/services/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal,
              private authService: AuthService
  ) { }

  userId: string;
  password: string;
  confirm: string;
  oldPassword: string;
  passwordMismatch: boolean = false;
  oldPasswordValue: boolean = false;
  newPasswordValue: boolean = false;
  confirmPasswordValue: boolean = false;
  incorrectOldPassword: boolean = false;
  passwordLength: boolean = false;
  samePassword: boolean = false;
  exceptionMsg: boolean = false;
  err: any;


  submit() {
    this.passwordMismatch = false;
    this.oldPasswordValue = false;
    this.newPasswordValue = false;
    this.confirmPasswordValue = false;
    this.incorrectOldPassword = false;
    this.exceptionMsg = false;
    this.passwordLength = false;
    this.samePassword = false;
    if (this.oldPassword && this.oldPassword.length > 0) {
      if (this.password && this.password.length > 0) {
        if (this.confirm && this.confirm.length > 0) {
          if (this.password === this.confirm) {
            if (this.password.length < 5) {
              this.passwordLength = true;
            } else {
                if (this.oldPassword === this.password) {
                  this.samePassword = true;
                } else {
                  this.passwordMismatch = false;
                  this.authService.changeUserPassword(this.userId, this.oldPassword, this.password).subscribe(success => {
                    if (success) {
                      this.activeModal.close();
                    } else {
                      this.incorrectOldPassword = true;
                    }
                  }, error => {
                    this.exceptionMsg = true;
                    this.err = error.error;
                  });
                }
              }
          } else {
            this.passwordMismatch = true;
          }
        } else {
          this.confirmPasswordValue = true;
        }
      } else {
        this.newPasswordValue = true;
      }
    } else {
      this.oldPasswordValue = true;
    }
  }

  ngOnInit() {
    //Empty ngOnInit()
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/change-password/change-password.component.ts